<p-autoComplete
    [(ngModel)]="value"
    [suggestions]="suggestions"
    (completeMethod)="UpdateSuggestions($event.query)"
    [dropdown]="true"
    [delay]="0"
    appendTo="body"
    [inputId]="inputId"
    [readonly]="readonly"
    [tabindex]="tabindex"
    [name]="name"
    field="description"
    [forceSelection]="true"
    [autoHighlight]="true"
    [disabled]="disabled"
    placeholder="Enter ZIP/Postal Code..."
    emptyMessage="No matching cities found."
    (onSelect)="Selected($event)"
    (onBlur)="Blurred()"
    (onFocus)="Focused()"
    (onClear)="Cleared()">
    <ng-template let-location pTemplate="item">
        <span>{{ location.description }}</span>
    </ng-template>
</p-autoComplete>
